import { render, staticRenderFns } from "./admitCardCountByCenter.vue?vue&type=template&id=5ccd68f0&scoped=true&"
import script from "./admitCardCountByCenter.vue?vue&type=script&lang=js&"
export * from "./admitCardCountByCenter.vue?vue&type=script&lang=js&"
import style0 from "./admitCardCountByCenter.vue?vue&type=style&index=0&id=5ccd68f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccd68f0",
  null
  
)

export default component.exports